import dynamic from 'next/dynamic';

const Accordion = dynamic(() =>
  import('../ContentElementsGdds/Accordion/accordion').then((module) => module.Accordion),
);

const NordicsAccordion = dynamic(() =>
  import('../ContentElementsGdds/NordicsAccordion/accordion').then((module) => module.Accordion),
);

const OnlineCatalogAssets = dynamic(() =>
  import('../ContentElementsGdds/online-catalog-assets').then(
    (module) => module.OnlineCatalogAssets,
  ),
);

const FAQAccordion = dynamic(() =>
  import('../ContentElementsGdds/Accordion/faq-accordion').then((module) => module.Accordion),
);

const CTAButton = dynamic(() =>
  import('../ContentElementsGdds/call-to-action/cta-button').then((module) => module.CTAButton),
);

const ButtonGroup = dynamic(() =>
  import('../ContentElementsGdds/button-group/button-group').then((module) => module.ButtonGroup),
);

const InteractiveHotspot = dynamic(() =>
  import('../ContentElementsGdds/interactive-hotspot/interactive-hotspot').then(
    (module) => module.InteractiveHotspot,
  ),
);

const HighlightTeaser = dynamic(() =>
  import('../ContentElementsGdds/HighlightTeaser/highlight-teaser').then(
    (module) => module.HighlightTeaser,
  ),
);

const ExpressiveTiles = dynamic(() =>
  import('../ContentElementsGdds/Tiles/expressive-tiles').then((module) => module.ExpressiveTiles),
);

const ProductiveTiles = dynamic(() =>
  import('../ContentElementsGdds/Tiles/productive-tiles').then((module) => module.ProductiveTiles),
);

const HeroTiles = dynamic(() =>
  import('../ContentElementsGdds/Tiles/hero-tiles').then((module) => module.HeroTiles),
);

const TextImage = dynamic(() =>
  import('../ContentElementsGdds/TextImage/text-image').then((module) => module.TextImage),
);

const CrmForms = dynamic(() =>
  import('../ContentElementsGdds/crm-forms/crm-forms').then((module) => module.CrmForms),
);

const TextMediaColumn = dynamic(() =>
  import('../ContentElementsGdds/TextImage/text-media-column').then(
    (module) => module.TextMediaColumn,
  ),
);

const ProductComparison = dynamic(() =>
  import('../ContentElementsGdds/product-comparison/product-comparison').then(
    (module) => module.ProductComparison,
  ),
);

const InvestorsCalendar = dynamic(() =>
  import('../ContentElementsGdds/investors-calendar/investors-calendar').then(
    (module) => module.InvestorsCalendar,
  ),
);

const IntroText = dynamic(() =>
  import('../ContentElementsGdds/IntroText/intro-text').then((module) => module.IntroText),
);

const Tabs = dynamic(() =>
  import('../ContentElementsGdds/Tabs/tabs').then((module) => module.GddsTabs),
);

const ImageGallery = dynamic(() =>
  import('../ContentElementsGdds/image-gallery/image-gallery').then(
    (module) => module.ImageGallery,
  ),
);

const Video = dynamic(() =>
  import('../ContentElementsGdds/video/video').then((module) => module.Video),
);

const DownloadsLinkList = dynamic(() =>
  import('../ContentElementsGdds/DownloadsLinkList/downloads-link-list').then(
    (module) => module.DownloadsLinkList,
  ),
);

const Quote = dynamic(() =>
  import('../ContentElementsGdds/Quote/quote').then((module) => module.Quote),
);

const InsightsTeaser = dynamic(() =>
  import('../ContentElementsGdds/Teaser/insights-teaser').then((module) => module.InsightsTeaser),
);

const IframeWrapper = dynamic(() =>
  import('../ContentElementsGdds/Iframe/iframe-wrapper').then((module) => module.IframeWrapper),
);

const FullGridImage = dynamic(() =>
  import('../ContentElementsGdds/FullGridImage/full-grid-image').then(
    (module) => module.FullGridImage,
  ),
);

const ChartTeaser = dynamic(() =>
  import('../ContentElementsGdds/ChartTeaser/chart-teaser').then((module) => module.ChartTeaser),
);

const Contact = dynamic(() =>
  import('../ContentElementsGdds/Contact/wrapper').then((module) => module.Wrapper),
);

const ProductSlider = dynamic(() =>
  import('../ContentElementsGdds/product-slider/product-slider').then(
    (module) => module.ProductSlider,
  ),
);

const Jobs = dynamic(() =>
  import('../ContentElementsGdds/Jobs/jobs').then((module) => module.Jobs),
);

const MediaReleases = dynamic(() =>
  import('../ContentElementsGdds/MediaReleases/media-releases').then(
    (module) => module.MediaReleases,
  ),
);

const WorldRegions = dynamic(() =>
  import('../ContentElementsGdds/world-map-section/world-regions').then(
    (module) => module.WorldRegions,
  ),
);

const ShowroomLocatorTeaser = dynamic(() =>
  import('../ContentElementsGdds/showroom-locator-teaser/showroom-locator-teaser').then(
    (module) => module.ShowroomLocatorTeaser,
  ),
);

const History = dynamic(() =>
  import('../ContentElementsGdds/history/history-container').then(
    (module) => module.HistoryContainer,
  ),
);

const TeaserTiles = dynamic(() =>
  import('../ContentElementsGdds/TeaserTilesNordics/teaser-tiles').then(
    (module) => module.TeaserTiles,
  ),
);

const SlidingTabs = dynamic(() =>
  import('../ContentElementsGdds/sliding-tabs/sliding-tabs').then((module) => module.SlidingTabs),
);

const ProductTiles = dynamic(() =>
  import('../ContentElementsGdds/Tiles/Product/product-tiles').then(
    (module) => module.ProductTiles,
  ),
);

const InteractiveDescription = dynamic(() =>
  import('../ContentElementsGdds/InteractiveDescriptions/interactive-description').then(
    (module) => module.InteractiveDescription,
  ),
);

const LeadModule = dynamic(() =>
  import('../ContentElementsGdds/lead-module/lead-module').then((module) => module.LeadModule),
);

const Locator = dynamic(() =>
  import('../ContentElementsGdds/locator/showroom').then((module) => module.ShowroomLocator),
);

const CiamProfile = dynamic(() =>
  import('../ContentElementsGdds/ciam/ciam-profile').then((module) => module.Profile),
);

const CiamVerification = dynamic(() =>
  import('../ContentElementsGdds/ciam/ciam-verification').then((module) => module.Verification),
);

const CiamReset = dynamic(() =>
  import('../ContentElementsGdds/ciam/ciam-reset').then((module) => module.Reset),
);

const Awards = dynamic(() =>
  import('../ContentElementsGdds/awards/awards').then((module) => module.Awards),
);

const CountrySwitch = dynamic(() =>
  import('../ContentElementsGdds/country-switch/country-switch').then(
    (module) => module.CountrySwitch,
  ),
);

const Picto = dynamic(() =>
  import('../ContentElementsGdds/picto/picto').then((module) => module.Picto),
);

const Table = dynamic(() =>
  import('../ContentElementsGdds/table/table').then((module) => module.Table),
);

const Usercentrics = dynamic(() =>
  import('../ContentElementsGdds/usercentrics/usercentrics').then((module) => module.Usercentrics),
);

const SectionSlider = dynamic(() =>
  import('../ContentElementsGdds/section-slider/section-slider').then(
    (module) => module.SectionSlider,
  ),
);

const PictureSlider = dynamic(() =>
  import('../ContentElementsGdds/picture-slider/picture-slider').then(
    (module) => module.PictureSlider,
  ),
);

const CountrySelector = dynamic(() =>
  import('../ContentElementsGdds/country-selector/country-selector').then(
    (module) => module.CountrySelector,
  ),
);

const ZipCodeSearch = dynamic(() =>
  import('../ContentElementsGdds/zip-code-search').then((module) => module.ZipCodeSearch),
);

const Form = dynamic(() =>
  import('../ContentElementsGdds/form/form-controller').then((module) => module.FormController),
);

const Oxomi = dynamic(() =>
  import('../ContentElementsGdds/oxomi/oxomi-section').then((module) => module.MemoizedOxomi),
);

const KeyFigure = dynamic(() =>
  import('../ContentElementsGdds/keyfigure/keyfigure').then((module) => module.KeyFigure),
);

export const contentElementsGdds = {
  accordion: { component: Accordion },
  accordion_nordics: { component: NordicsAccordion },
  button_group: { component: ButtonGroup },
  faq_accordion: { component: FAQAccordion },
  call_to_action_button: { component: CTAButton },
  expressive_tiles: { component: ExpressiveTiles },
  productive_tiles: { component: ProductiveTiles },
  hero_tiles: { component: HeroTiles },
  tiles: { component: ProductiveTiles },
  tabs_nordics: { component: SlidingTabs },
  investors_calendar: { component: InvestorsCalendar },
  interactive_hotspot: { component: InteractiveHotspot },
  highlight_teaser_section: { component: HighlightTeaser },
  intro_section: { component: IntroText },
  tabs: { component: Tabs, isContainer: true },
  image_gallery_group: { component: ImageGallery },
  nordics_image_gallery: { component: ImageGallery },
  image_gallery: { component: ImageGallery },
  video_section: { component: Video },
  downloads_and_link_list: { component: DownloadsLinkList },
  quote: { component: Quote },
  insights_teaser_section: { component: InsightsTeaser },
  iframe_content_section: { component: IframeWrapper },
  full_grid_image: { component: FullGridImage },
  charts: { component: ChartTeaser },
  contact: { component: Contact },
  interactive_product_slider: { component: ProductSlider },
  before_after_slider: { component: ProductSlider },
  jobs_section: { component: Jobs },
  history: { component: History },
  text_image: { component: TextImage },
  text_media: { component: TextImage },
  crm_forms: { component: CrmForms },
  text_media_columns_section: { component: TextMediaColumn },
  media_releases: { component: MediaReleases },
  world_map_section: { component: WorldRegions },
  showroom_locator_teaser: { component: ShowroomLocatorTeaser },
  contact_tiles: { component: ProductiveTiles },
  nordics_product_tiles: { component: ProductTiles },
  nordics_teaser_tiles: { component: TeaserTiles },
  product_tiles: { component: ProductTiles },
  nordics_interactive_description: { component: InteractiveDescription },
  nordics_lead_module: { component: LeadModule },
  interactive_description: { component: InteractiveDescription },
  locator: { component: Locator },
  ciam_verification: { component: CiamVerification },
  ciam_pw: { component: CiamReset },
  profile_page_embedded: { component: CiamProfile },
  awards: { component: Awards },
  country_switch: { component: CountrySwitch },
  picto: { component: Picto },
  table: { component: Table },
  usercentrics: { component: Usercentrics },
  section_slider: { component: SectionSlider },
  picture_slider: { component: PictureSlider },
  product_comparison: { component: ProductComparison },
  online_catalog_assets: { component: OnlineCatalogAssets },
  oxomi: { component: Oxomi },
  country_selector: { component: CountrySelector },
  zip_code_search: { component: ZipCodeSearch },
  form: { component: Form },
  keyfigure_box: { component: KeyFigure },
};
